const getReference = (obj, reference, newType = "array") => {
	let result = obj;
	/*eslint no-useless-escape: "off"*/
	let arrayWithArrayKeys = reference.match(/[^.]+/g);
	try {
		arrayWithArrayKeys.forEach((key, index) => {
			let keyParts = key.split("[");
			for (var i = 0; i < keyParts.length; i++) {
				if (i === 0 && keyParts.length > 1) {
					if (result[keyParts[0]] === undefined) {
						result[keyParts[0]] = [];
					}
					result = result[keyParts[0]];
				} else if (i === 0 && index < arrayWithArrayKeys.length - 1) {
					if (result[keyParts[0]] === undefined) {
						result[keyParts[0]] = {};
					}
					result = result[keyParts[0]];
				} else {
					let part = keyParts[i].replace("]", "");
					if (i !== 0) {
						part = parseInt(part, 10);
					}
					if (i < keyParts.length - 2) {
						if (result[part] === undefined) {
							result[part] = [];
						}
					} else if (i < keyParts.length) {
						if (result[part] === undefined) {
							if (newType === "array") {
								result[part] = [];
							} else if (newType === "object") {
								result[part] = {};
							}
						}
					}
					result = result[part];
				}
			}
		});
		return result;
	} catch (error) {
		return undefined;
	}
};

export default getReference;
